// Token Exporter Utility
// This can be used to export tokens from localStorage for backup or testing

const exportTokensFromLocalStorage = () => {
    console.log('🔍 Checking for MYOB tokens in localStorage...');
    
    const tokenKeys = [
        'myob_tokens',
        'myob_streamlined_tokens', 
        'myob_auto_tokens',
        'myob_direct_tokens'
    ];
    
    const foundTokens = {};
    
    tokenKeys.forEach(key => {
        const tokens = localStorage.getItem(key);
        if (tokens) {
            try {
                const parsedTokens = JSON.parse(tokens);
                foundTokens[key] = parsedTokens;
                console.log(`✅ Found tokens in ${key}:`);
                console.log(`   - Access Token: ${parsedTokens.access_token ? parsedTokens.access_token.substring(0, 30) + '...' : 'Not found'}`);
                console.log(`   - Refresh Token: ${parsedTokens.refresh_token ? parsedTokens.refresh_token.substring(0, 30) + '...' : 'Not found'}`);
                console.log(`   - Expires At: ${parsedTokens.expires_at ? new Date(parsedTokens.expires_at).toLocaleString() : 'Not found'}`);
                console.log(`   - Business ID: ${parsedTokens.business_id || 'Not found'}`);
                console.log(`   - Scope: ${parsedTokens.scope || 'Not found'}`);
                console.log('');
            } catch (error) {
                console.error(`❌ Error parsing tokens from ${key}:`, error);
            }
        }
    });
    
    if (Object.keys(foundTokens).length === 0) {
        console.log('❌ No MYOB tokens found in localStorage');
        return null;
    }
    
    // Export to file
    const exportData = {
        exported_at: new Date().toISOString(),
        tokens: foundTokens,
        note: 'MYOB OAuth Tokens - Keep secure!'
    };
    
    const blob = new Blob([JSON.stringify(exportData, null, 2)], {
        type: 'application/json'
    });
    
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `myob-tokens-export-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    console.log('📁 Tokens exported to file successfully!');
    return exportData;
};

// Function to import tokens back to localStorage
const importTokensToLocalStorage = (tokenData) => {
    console.log('📥 Importing tokens to localStorage...');
    
    if (!tokenData || !tokenData.tokens) {
        console.error('❌ Invalid token data format');
        return false;
    }
    
    Object.entries(tokenData.tokens).forEach(([key, tokens]) => {
        try {
            localStorage.setItem(key, JSON.stringify(tokens));
            console.log(`✅ Imported tokens to ${key}`);
        } catch (error) {
            console.error(`❌ Error importing tokens to ${key}:`, error);
        }
    });
    
    console.log('✅ Token import completed!');
    return true;
};

// Function to clear all MYOB tokens
const clearAllMYOBTokens = () => {
    console.log('🗑️ Clearing all MYOB tokens...');
    
    const tokenKeys = [
        'myob_tokens',
        'myob_streamlined_tokens', 
        'myob_auto_tokens',
        'myob_direct_tokens',
        'myob_company_files'
    ];
    
    tokenKeys.forEach(key => {
        if (localStorage.getItem(key)) {
            localStorage.removeItem(key);
            console.log(`✅ Cleared ${key}`);
        }
    });
    
    console.log('✅ All MYOB tokens cleared!');
};

// Make functions available globally for console use
if (typeof window !== 'undefined') {
    window.exportMYOBTokens = exportTokensFromLocalStorage;
    window.importMYOBTokens = importTokensToLocalStorage;
    window.clearMYOBTokens = clearAllMYOBTokens;
    
    console.log('🔧 MYOB Token Utilities loaded!');
    console.log('Available functions:');
    console.log('- exportMYOBTokens() - Export all tokens to file');
    console.log('- importMYOBTokens(tokenData) - Import tokens from data');
    console.log('- clearMYOBTokens() - Clear all MYOB tokens');
}

export {
    exportTokensFromLocalStorage,
    importTokensToLocalStorage,
    clearAllMYOBTokens
};
